import React from 'react';
import { authorities } from '../AuthorityLogos';

const EXTRA = ['DED', 'DIFC', 'DMCC', 'IFZA', 'RAKEZ', 'ADGM', 'FTA', 'Emirates NBD', 'FAB', 'Mashreq'];

export const AuthorityMarquee = ({ lang }) => {
  const ar = lang === 'ar';
  const items = [
    ...authorities.map((a) => ({ key: a.key, node: <a.Logo className="h-9 max-w-[140px]" />, title: a.name[lang] })),
    ...EXTRA.map((n) => ({ key: n, node: <span className="font-display text-lg text-[#111827]/60 whitespace-nowrap">{n}</span>, title: n })),
  ];
  const track = [...items, ...items];
  return (
    <section className="relative py-10 border-y border-[#e5e7eb] dark:border-slate-800 bg-white/60 dark:bg-slate-900/40" data-testid="authority-marquee">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center text-[11px] uppercase tracking-[0.3em] text-[#2563eb] mb-6">{ar ? 'معتمدون ومتوافقون مع' : 'Approved & compliant with'}</div>
        <div className="relative overflow-hidden marquee-mask" dir="ltr">
          <div className="marquee-track flex items-center gap-14 w-max">
            {track.map((it, i) => (
              <div key={`${it.key}-${i}`} className="flex items-center justify-center opacity-70 hover:opacity-100 transition-opacity grayscale hover:grayscale-0" title={it.title}>{it.node}</div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
